<script setup lang="ts">
interface Props {
  count?: number
}

const props = withDefaults(defineProps<Props>(), {
  count: 10
})
</script>

<template>
  <div class="space-y-2">
    <div
      v-for="n in props.count"
      :key="n"
      class="flex animate-pulse items-center justify-between rounded-lg bg-white p-6"
    >
      <div class="flex items-center gap-3">
        <div class="h-6 w-6 rounded-full bg-gray-300" />
        <div class="h-4 w-48 rounded bg-gray-300" />
      </div>
    </div>
  </div>
</template>
